import React from "react";

const FortellisTitle1 = ({ title }) => {
  return <div className="fortellis-title-1">{title}</div>;
};

export default FortellisTitle1;
